// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, Link, Redirect } from "react-router-dom";
import styled from "../common/styled";
import * as actions from "../actions";
import { compose } from "../common/utils";
import { authUser, signOut } from "../common/aws_lib";
import { Button, Table } from "reactstrap";
import CategoryForm from "../components/CategoryForm";
import SettingsForm from "../components/SettingsForm";
import * as API from "../common/api";
// import { remote, nativeImage } from 'electron';
import fs from "fs";
import path from "path";
import { toast } from "react-toastify";

const { Text, Image, View } = styled.plain;

class CategoryPage extends React.Component {
  state = {
    isLogined: null,
    showForm: false,
    showSettingsForm: false,
    formConfig: {},
    mode: "ADD"
  };

  componentDidMount() {
    this.setInitialHeader();

    authUser()
      .then(isLogined => {
        this.setState({ isLogined });
        if (isLogined) {
          this.loadData();
        } else {
          this.props.history.push("/login");
        }
        return isLogined;
      })
      .catch(() => {
        this.setState({ isLogined: false });
      });
  }

  setInitialHeader() {
    this.props.setHeader((restore, header) => ({
      title: "",
      right: "",
      left: ""
    }));
  }

  loadData = () => {
    this.props.loadCategories();
  };

  onLogout = () => {
    signOut();
    this.props.history.push("/login");
  };

  onAddCategory = () => {
    this.setState({
      showForm: true,
      mode: "ADD",
      formConfig: {
        categoryName: "",
        subcategories: []
      }
    });
  };

  onCategoryFormOpen = (item, index) => {
    this.setState({
      showForm: true,
      mode: "EDIT",
      formConfig: {
        categoryName: item.categoryName,
        subcategories: item.subcategories
      }
    });
  };

  onCategoryFormClose = () => {
    this.setState({ showForm: false });
  };

  onCategoryFormDone = () => {
    this.setState({ showForm: false });
    setTimeout(() => {
      this.loadData();
    }, 1500);
    
  };

  render() {
    if (this.state.isLogined === false) {
      // return <Redirect to="/login" />;
    }
    const { categories } = this.props;

    return (
      <View style={{ height: "100%" }}>
        <Container>
          <Button
            className="tabButton"
            color="primary"
            outline
            onClick={() => {
              this.props.history.push("/");
            }}
          >
            Photos
          </Button>
          <Button className="tabButton" color="primary">
            Categories
          </Button>
          <Button
            className="tabButton"
            color="primary"
            outline
            onClick={() => {
              this.setState({ showSettingsForm: true });
            }}
          >
            Settings
          </Button>
          <span className="divider" />

          <Button
            className="tabButton"
            color="success"
            outline
            onClick={this.onAddCategory}
          >
            Add Category
          </Button>
          <Button className="iconButton" color="link" onClick={this.onLogout}>
            <i style={{ fontSize: "20px" }} className="fa fa-external-link" />
          </Button>
        </Container>
        <ItemContainer>
          <Table hover>
            <thead>
              <tr>
                <th>Category</th>
                <th>Subcategories</th>
              </tr>
            </thead>
            <tbody>
              {categories &&
                categories.map((item, index) => (
                  <tr
                    style={{ cursor: "pointer" }}
                    key={item.categoryName}
                    onClick={() => this.onCategoryFormOpen(item, index)}
                  >
                    <th scope="row">{item.categoryName}</th>
                    <td>
                      {item.subcategories && item.subcategories.join(", ")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </ItemContainer>

        {this.state.showForm ? (
          <CategoryForm
            {...this.state.formConfig}
            type={this.state.mode}
            visible={this.state.showForm}
            onClose={this.onCategoryFormClose}
            onDone={this.onCategoryFormDone}
          />
        ) : (
          ""
        )}

        {this.state.showSettingsForm ? (
          <SettingsForm
            visible={this.state.showSettingsForm}
            onClose={() => this.setState({ showSettingsForm: false })}
            onDone={() => this.setState({ showSettingsForm: false })}
          />
        ) : (
          ""
        )}
      </View>
    );
  }
}

const Container = styled.View`
  padding: 15px;
  border-bottom: 2px solid ${styled.mainColor};
  margin-left: 10px;
  margin-right: 10px;
`;

const ItemContainer = styled.View`
  padding: 10px;
  height: auto;
  overflow-y: auto;
  height: calc(100% - 70px);
`;

const Item = styled.View`
  display: inline-block;
  // height: 200px;
  width: 200px;
  background: none;
  margin: 10px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  text-align: left;
  vertical-align: top;
  background: #fbfbfb;
  border-radius: 4px;
  overflow: hidden;
`;

export default compose(
  connect(
    state => ({
      categories: state.categories.list
    }),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(CategoryPage);
